// extracted by mini-css-extract-plugin
var _1 = "_128SZ";
var _2 = "lNC0ZP";
var _3 = "YO9knm";
var _4 = "tOjZRG";
var _5 = "tOjZRG";
var _6 = "BiUtNS";
var _7 = "PKwIRi";
var _8 = "SvzuvT";
var _9 = "AZpQy6";
var _a = "HgYdRQ";
var _b = "w3bZFZ";
var _c = "vqM_pr";
var _d = "VJOTWg";
var _e = "Gx9_cd";
var _f = "uC2tCh";
var _10 = "Cl9RB6";
var _11 = "JDINaF";
var _12 = "y3Iwjg";
export { _1 as "btn", _2 as "disabled", _3 as "fullwidth", _4 as "helper-remove", _5 as "helperRemove", _6 as "large", _7 as "login", _8 as "medium", _9 as "primary", _a as "register", _b as "reset", _c as "secondary", _d as "small", _e as "submitting", _f as "text", _10 as "typing", _11 as "valid", _12 as "xsmall" }
